/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  bool,
  string,
  shape,
  func,
} from 'prop-types';
import classNames from 'classnames';
import 'components/product/ProductPane/MobileButtonGroup.scss';
import {
  Button,
} from 'components/common';
import MobilePremiumCompareElement from 'components/product/ProductPane/MobilePremiumCompareElement';
import { onCtaClick } from 'money101/TWUtils';

export const staticTextKeys = [
  'defaultCTALabel',
  'accordionShowMore',
  'accordionShowLess',
];

const MobileButtonGroup = (props) => {
  const {
    ctaButton = {},
    isAccordionPanelShow,
    onShowMoreButtonClick = undefined,
    premiumCompareElement,
    staticText,
    onCtaLinkClick,
    name,
    showModal,
  } = props;

  const openKGIModal = (el) => {
    if (name === '凱基銀行 個人信貸 超低利率專案') {
      showModal();
    } else {
      onCtaClick(ctaButton, onCtaLinkClick, el);
    }
  };

  return (
    <div className="mobile-button-group">
      {(premiumCompareElement || (ctaButton && ctaButton.show)) && (
        <div className={classNames('premium-cta-wrapper', { 'has-premium': !!premiumCompareElement })}>
          {premiumCompareElement && (
            <div className="premium-compare-element-wrapper">
              <MobilePremiumCompareElement
                {...premiumCompareElement}
                ctaButton={ctaButton}
                onCtaLinkClick={onCtaLinkClick}
              />
            </div>
          )}
          {ctaButton && ctaButton.show && (
            <div className="cta-button-wrapper">
              <Button
                primary
                fluid
                onClick={openKGIModal}
              >
                {ctaButton.label || staticText.defaultCTALabel}
              </Button>
            </div>
          )}
        </div>
      )}
      <div
        className="mobile-show-more-wrapper"
        onClick={onShowMoreButtonClick}
      >
        <Button
          text
          rightIconName={isAccordionPanelShow ? 'chevron_up' : 'chevron_down'}
        >
          {isAccordionPanelShow ? staticText.accordionShowLess : staticText.accordionShowMore}
        </Button>
      </div>
    </div>
  );
};

MobileButtonGroup.defaultProps = {
  premiumCompareElement: null,
  premiumLabel: null,
  ctaButton: null,
  staticText: {},
  onCtaLinkClick: undefined,
  name: '',
  showModal: undefined,
};

MobileButtonGroup.propTypes = {
  ctaButton: shape({
    show: bool.isRequired,
    label: string.isRequired,
  }),
  isAccordionPanelShow: bool.isRequired,
  onShowMoreButtonClick: func.isRequired,
  premiumLabel: string,
  premiumCompareElement: shape({}),
  staticText: shape({
    accordionShowLess: string,
    accordionShowMore: string,
    defaultCTALabel: string,
  }),
  onCtaLinkClick: func,
  name: string,
  showModal: func,
};

export default MobileButtonGroup;
